module.exports = __webpack_public_path__ + "img/New-Romantics_fr.c00257b1.jpg";